import React, { useState, useEffect } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import ReLoginModal from "../ReLoginModal";
import { toast, ToastContainer } from "react-toastify";

const FundWallet = ({ handleFund, getUserBank }: any) => {
  const [reLogin, setReLogin] = useState(false);
  const [cusID, setCusId] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedBank, setSelectedBank] = useState<any>(null);
  const token = window.localStorage.getItem("token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const [funding, setFunding] = useState({
    customerWallet: "",
    bank: "",
    product: "",
  });

  const [products, setProducts] = useState<any[]>([]);

  useEffect(() => {
    if (selectedBank && selectedBank.product) {
      setProducts(selectedBank.product);
    } else if (getUserBank && getUserBank.length > 0) {
      // Default to the first bank's product if no bank is selected yet
      setProducts(getUserBank[0].product || []);
    }
  }, [selectedBank, getUserBank]);

  const handleFundChange = ({ target: { name, value } }: any) => {
    setFunding((prevSign) => ({
      ...prevSign,
      [name]: value,
    }));
  };

  const handleBankChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedBankId = e.target.value;
    setCusId(selectedBankId);
    const selectedBank = getUserBank.find((bank: any) => bank._id === selectedBankId);
    setSelectedBank(selectedBank);
    setProducts(selectedBank?.product || []);
  };

  const handleFundSubmit = (e: any) => {
    e.preventDefault();
    if (!cusID || !funding.product || !funding.customerWallet) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);
    axios
      .patch(
        `https://apibiz.oneflaretech.com/api/customer/account/${cusID}`,
        {
          amount: funding.customerWallet,
          product: funding.product,
        },
        { headers: headers }
      )
      .then((res) => {
        Swal.fire({
          title: `Success!`,
          text: `Customer account updated successfully. \n We're performing a reload in 3 seconds`,
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "green",
          confirmButtonText: "Continue",
        });
        setLoading(false);
        setTimeout(() => {
          window.location.reload();
        }, 4000);
      })
      .catch((err) => {
        Swal.fire({
          title: `Error!`,
          text: `${err.response.data.message}`,
          icon: "error",
          showCancelButton: false,
          confirmButtonColor: "red",
          confirmButtonText: "Try Again",
        });
        if (
          err.response.data.message === "jwt expired" ||
          err.response.data.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setLoading(false);
      });
  };

  return (
    <div className="modal">
      <ToastContainer />
      <form onSubmit={handleFundSubmit} className="catModal">
        <div className="catModalTop">
          <h4>Pay To Existing Bank</h4>
          <ImCancelCircle className="catCancel" onClick={handleFund} />
        </div>
        <div className="line"></div>
        {reLogin ? <ReLoginModal /> : null}

        <div className="catModalInput branchInput">
          <select name="bank" onChange={handleBankChange} value={cusID}>
            <option value="">Select Bank</option>
            {getUserBank.map((bank: any) => (
              <option key={bank._id} value={bank._id}>
                {bank.bank.bankName}
              </option>
            ))}
          </select>
          <select
            name="product"
            onChange={handleFundChange}
            value={funding.product}
          >
            <option value="">Select Product</option>
            {products.map((product: any) => (
              <option key={product._id} value={product._id}>
                {product.name}
              </option>
            ))}
          </select>

          <input
            type="text"
            placeholder="Amount"
            required
            name="customerWallet"
            value={funding.customerWallet}
            onChange={handleFundChange}
          />
        </div>

        <div className="catModalBtn">
          <button type="submit" className="catBtn1">
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: "25px", height: "25px" }}
              />
            ) : (
              "Pay"
            )}
          </button>
          <button className="catBtn2" onClick={handleFund}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default FundWallet;